export default "__VITE_ASSET__aaf79b74__"